// 날짜 관련 상수 정의
export const DATE_CONSTANTS = {
  WEEK: 7,
  MONTH: 31,
  THREE_MONTHS: 93,
  DATE_FORMAT: "YYYY-MM-DD" as const,
  DATETIME_FORMAT: "YYYY-MM-DD HH:mm:ss" as const,
} as const;

// 기간 선택 탭 정의
export const PERIOD_TABS = [
  { index: 0, name: "전1주", days: DATE_CONSTANTS.WEEK },
  { index: 1, name: "전월", days: DATE_CONSTANTS.MONTH },
  { index: 2, name: "전3개월", days: DATE_CONSTANTS.THREE_MONTHS },
] as const;
